export const checkMultiuse = async formData => {
  const redeemedJSON = fetch('/.netlify/functions/gift-multiuse-check', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then(r => r.json())
    .catch(err => console.error(err))

  return redeemedJSON
}
